<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-card-title class="text-h5">
        Subscription Expired
      </v-card-title>
      <v-card-text class="pt-4">
        {{ message }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="handleClose">
          Close
        </v-btn>
        <v-btn class="primary-btn" text @click="handleClose">
          Acknowledge
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SubscriptionExpiredModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: 'Your subscription has expired. Please contact your account manager.',
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    handleClose() {
      this.$emit('acknowledge');
      this.dialog = false;
    },
  },
};
</script>
